import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=1be4dff0&scoped=true&"
import script from "./ProductOrder.vue?vue&type=script&lang=js&"
export * from "./ProductOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrder.vue?vue&type=style&index=0&id=1be4dff0&lang=scss&scoped=true&"
import style1 from "./ProductOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be4dff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1be4dff0')) {
      api.createRecord('1be4dff0', component.options)
    } else {
      api.reload('1be4dff0', component.options)
    }
    module.hot.accept("./ProductOrder.vue?vue&type=template&id=1be4dff0&scoped=true&", function () {
      api.rerender('1be4dff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/merchant/ProductOrder.vue"
export default component.exports